export default function Hero() {
  return (
    <section
      className="relative h-[90vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('/portfolio/bmw.jpeg')",
      }}
    >
      <div className="absolute inset-0 bg-black/70"></div>

      <div className="relative z-10 flex h-full items-center justify-center px-6">
        <div className="mx-auto max-w-6xl text-center">

          <p className="mb-6 text-xl font-bold tracking-[10px] text-sky-400">
            WELCOME TO
          </p>

          <h1 className="text-5xl font-black leading-tight text-white md:text-6xl lg:text-7xl">
            CUSTOM T SHIRT BAR
          </h1>

          <p className="mt-8 text-2xl text-gray-300">
            Premium DTF Printing • Custom Clothing • Business Branding
          </p>

          <div className="mt-12 flex flex-wrap justify-center gap-6">
            <a
              href="https://wa.me/27660198386"
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-sky-500 px-10 py-6 text-xl font-bold text-white transition hover:scale-105 hover:bg-sky-400"
            >
              Order on WhatsApp
            </a>

            <a
              href="#portfolio"
              className="rounded-full border-2 border-white px-10 py-5 text-xl font-bold text-white transition hover:bg-white hover:text-black"
            >
              View Portfolio
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}